import { render, staticRenderFns } from "./CapituloDiezPage.vue?vue&type=template&id=f887c2e4"
import script from "./CapituloDiezPage.js?vue&type=script&lang=js&external"
export * from "./CapituloDiezPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports